import { i18n } from "./i18n.js";

const HERETIC_BASE = "https://heretic.giglabo.com";

function head(locale: string | undefined): "ru" | "en" {
  if (!locale) return "en";
  const code = locale.toLowerCase().split("-")[0];
  return code === "ru" ? "ru" : "en";
}

export function hereticAppUrl(
  slug = "telegram-post-editor",
  locale: string = i18n.language,
): string {
  const prefix = head(locale) === "ru" ? "/ru" : "";
  return `${HERETIC_BASE}${prefix}/applications/${slug}`;
}

export function hereticOgImage(locale: string = i18n.language): string {
  return `${HERETIC_BASE}/heretic-static/public/images/telegram-post-editor-og-${head(locale)}.png`;
}

export function appDisplayName(locale: string = i18n.language): string {
  return head(locale) === "ru" ? "Редактор постов Telegram" : "Telegram Post Editor";
}
